import { clearModalHack } from '@/services/utils';
import Company from '@/services/UserService/company';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import MainHeader from '@/components/MainHeader.vue';
import PracticeAreaEdit from './PracticeAreaEdit.vue';
export default {
  name: 'SharedMatterTags',
  data() {
    return {
      loading: true,
      mattertags: undefined,
      me: undefined,
      showEditDialog: false,
      selectedTag: null,
      requireMatterTag: false
    };
  },
  props: {
    leanLawApi: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    matterTagsService: {
      type: Object,
      required: true
    }
  },
  components: {
    LlCheckbox,
    LlSecondaryButton,
    MainHeader,
    PracticeAreaEdit
  },
  async mounted() {
    this.loading = true;
    this.me = await this.userService.getMe();
    this.requireMatterTag = this.me.company.settings.requireMatterTag;
    this.mattertags = await this.matterTagsService.getMatterTags();
    this.loading = false;
  },
  methods: {
    settingsUpdate() {
      new Company(this.leanLawApi).update({
        settings: {
          requireMatterTag: this.requireMatterTag
        }
      });
    },
    async editMatterTag(tag) {
      this.selectedTag = tag || null;
      this.showEditDialog = true;
    },
    handleSave(tagData) {
      this.createOrUpdateTags(tagData);
      this.showEditDialog = false;
    },
    handleDelete(deleteData) {
      this.removeTags(deleteData);
      this.showEditDialog = false;
    },
    handleCancel() {
      this.showEditDialog = false;
      this.selectedTag = null;
    },
    createOrUpdateTags(result) {
      const duplicateTag = this.mattertags.find(m => m.label.toLowerCase() === result.label.toLowerCase());
      if (!result.id && duplicateTag) {
        duplicateTag.active = true;
        setTimeout(() => {
          duplicateTag.active = false;
        }, 1500);
        return;
      }
      this.updateMatterTag(result);
    },
    removeTags(tag) {
      this.leanLawApi.deleteMatterTag({
        id: tag.tag.id,
        reassign: tag.reassign
      }).then(() => {
        const deleteIndex = this.mattertags.findIndex(t => t.id === tag.tag.id);
        this.mattertags.splice(deleteIndex, 1);
        this.matterTagsService.reset();
      }).catch(e => this.alerts.error(e));
    },
    updateMatterTag(tag) {
      const api = tag.id ? this.leanLawApi.updateMatterTag({
        id: tag.id,
        body: tag
      }) : this.leanLawApi.createMatterTag({
        body: tag
      });
      api.then(updated => {
        const existingTag = this.mattertags.find(t => t.id === updated.id);
        this.matterTagsService.reset();

        // If this practice area is being set as default, unset all others
        if (updated.default) {
          this.mattertags.forEach(t => {
            if (t.id !== updated.id) {
              t.default = false;
            }
          });
        }
        if (existingTag) {
          Object.assign(existingTag, updated);
        } else {
          updated.matterCount = 0;
          this.mattertags.push(updated);
        }
      }).catch(e => this.alerts.error(e));
    }
  }
};